import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuditLogService } from './audit-log.service';
import { AuditLogListItem } from '@models/resources/audit-log.model';
import { DEMO_AUDIT_LOGS } from '@data/fixtures/audit-logs.fixtures';
import { dummyResponse } from '@data/dummy-response.util';

/**
 * Dummy-Variante für Sprint 1–3. Filtert `DEMO_AUDIT_LOGS` nach
 * `auditable_type` + `auditable_id` und sortiert aufsteigend nach
 * `created_at` (ältester Eintrag zuerst, damit der Staff die Historie
 * chronologisch von oben nach unten liest).
 */
@Injectable()
export class DummyAuditLogService implements AuditLogService {
  getForEntity(
    auditableType: string,
    auditableId: number,
  ): Observable<AuditLogListItem[]> {
    const entries = DEMO_AUDIT_LOGS.filter(
      (l) => l.auditable_type === auditableType && l.auditable_id === auditableId,
    ).sort((a, b) => a.created_at.localeCompare(b.created_at));
    return dummyResponse('audit.logs', entries);
  }
}
